import { render, staticRenderFns } from "./LockTicket.vue?vue&type=template&id=4d8e2200&scoped=true&"
import script from "./LockTicket.vue?vue&type=script&lang=js&"
export * from "./LockTicket.vue?vue&type=script&lang=js&"
import style0 from "./LockTicket.vue?vue&type=style&index=0&id=4d8e2200&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e2200",
  null
  
)

export default component.exports